<template>
	<div class="flex flex-col items-center gap-1">
		<button type="button" :class="`rounded px-3 ${isActive ? 'bg-gray-300 dark:bg-gray-700' : 'hover:bg-gray-200 hover:dark:bg-gray-800'}`">
			<slot/>
		</button>
		<p class="text-[8px]">{{ title }}</p>
	</div>
</template>
<script setup lang="ts">
defineProps<{
	title:string,
	isActive?:boolean,
}>()
</script>